<template>
  <div class="commonfoot">
    <v-line></v-line>
    <div class="container text-sm-left text-center">
      <div class="row">
        <div class="col-sm-4" v-if="this.footleftmenu.length">
          <ul>
            <li v-for="item in footleftmenu" :key="'left'+item.ID">
              <a class="secondary_title" :href="item.path||item.url">{{item.title}}</a>
            </li>
          </ul>
        </div>
        <div class="col-sm-4" v-if="this.footleftmenu.length">
          <ul v-if="this.footmenu.length>=6">
            <li v-for="item  in footcentermenu" :key="'center'+item.ID">
              <a class="secondary_title" :href="item.path||item.url">{{item.title}}</a>
            </li>
          </ul>
        </div>
        <div
          class="commonfootright text-center"
          :class="{'col-sm-4':this.footleftmenu.length,
        'col-12':!this.footleftmenu.length,
        'text-sm-right':this.footleftmenu.length}"
        >
          <p> <a href="/policies/ip" style="color:#212529;">DMCA report</a> </p>
          <p>© {{new Date().getFullYear()}},{{title}}</p>
          <v-selectlang :langs="langs" :langs_meta="langs_meta" :enabled="enabled" theme="Brooklyn"></v-selectlang>
           <v-payicon v-if="show_payment_icons" :wrapstyle="{'margin-top':enabled?'0':'15px'}"  :paylist="['PayPal','Visa','Mastercard','Dicover','Diners Club International']"></v-payicon>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["title", "footmenu", "show_payment_icons", "langs", "enabled","langs_meta"],
  data() {
    return {
      footleftmenu: [],
      footcentermenu: [],
    };
  },
  mounted() {
    if (this.footmenu.length > 5) {
      this.footcentermenu = this.footmenu.slice(
        Math.ceil(this.footmenu.length / 2)
      );
      this.footleftmenu = this.footmenu.slice(
        0,
        Math.ceil(this.footmenu.length / 2)
      );
    } else {
      this.footleftmenu = this.footmenu;
    }
  },
};
</script>
<style scoped lang='scss'>
.commonfoot {
  padding-top: 90px;
  text-align: center;
  ul {
    padding: 0;
    li {
      list-style: none;
    }
  }
  .container {
    padding: 30px 0;
    .row {
      margin: 0;
      ul {
        margin: 0;
        li {
          margin-bottom: 4.5px;
          a {
            font-size: 16px;
            text-decoration: none;
            color: #000;
          }
        }
      }
    }

    p {
      padding: 0;
      margin: 0;
    }
  }
}
</style>